import {
    TextField,
    TextAreaField,
    SelectField,
    Flex,
    Text,
} from "@aws-amplify/ui-react";
import { LISTING_TYPES, LIMITS } from "./listingModel";

// Presentational only: no state, no API calls. Props in, onChange(field, value) out.
const TITLE_MAX = LIMITS.title[1];
const DESCRIPTION_MAX = LIMITS.description;
const LINKS_MAX = LIMITS.links;

const TYPE_LABELS = {
    brand: "Brand looking for influencers",
    influencer: "Influencer offering collabs",
};

export function BasicFields({ values, errors, onChange, isEdit }) {
    const description = values.description || "";
    return (
        <Flex direction="column" gap="1rem">
            <TextField
                label="Title"
                value={values.title || ""}
                maxLength={TITLE_MAX}
                onChange={(e) => onChange("title", e.target.value)}
                hasError={!!errors.title}
                errorMessage={errors.title}
            />
            <SelectField
                label="Listing type"
                value={values.listingType || ""}
                onChange={(e) => onChange("listingType", e.target.value)}
                hasError={!!errors.listingType}
                errorMessage={errors.listingType}
            >
                {LISTING_TYPES.map((type) => (
                    <option key={type} value={type}>
                        {TYPE_LABELS[type] || type}
                    </option>
                ))}
            </SelectField>
            <TextAreaField
                label="Description"
                rows={8}
                value={description}
                descriptiveText={`Markdown supported, up to ${DESCRIPTION_MAX} characters`}
                onChange={(e) => onChange("description", e.target.value)}
                hasError={!!errors.description}
                errorMessage={errors.description}
            />
            <Text fontSize="small" color="font.tertiary">
                {description.length}/{DESCRIPTION_MAX}
            </Text>
        </Flex>
    );
}

export function MediaFields({ values, errors, onChange }) {
    const links = Array.isArray(values.links) ? values.links : [];
    return (
        <Flex direction="column" gap="1rem">
            <TextField
                label="Image URL"
                placeholder="https://…/image.jpg"
                value={values.imageUrl || ""}
                onChange={(e) => onChange("imageUrl", e.target.value)}
                hasError={!!errors.imageUrl}
                errorMessage={errors.imageUrl}
            />
            {values.imageUrl ? (
                <img
                    src={values.imageUrl}
                    alt=""
                    style={{ maxHeight: 120, maxWidth: "100%", objectFit: "contain" }}
                />
            ) : null}
            <TextField
                label="Video URL"
                placeholder="YouTube URL"
                descriptiveText="YouTube watch / short link"
                value={values.videoUrl || ""}
                onChange={(e) => onChange("videoUrl", e.target.value)}
                hasError={!!errors.videoUrl}
                errorMessage={errors.videoUrl}
            />
            <TextAreaField
                label={`Example / other links (one per line, up to ${LINKS_MAX})`}
                rows={3}
                value={links.join("\n")}
                onChange={(e) => onChange("links", e.target.value.split("\n"))}
                hasError={!!errors.links}
                errorMessage={errors.links}
            />
        </Flex>
    );
}
